import { css } from "@emotion/css";
import { Routes, Route } from "react-router-dom";
import Navbar from "../../shared/components/navbar/navbar";
import Footer from "../../shared/components/footer/footer";
import CommercialIndex from "./subpages/commercial-index";
import Sponsor from "./subpages/sponsor";
import SellEvent from "./subpages/sell-event";
import GroupSales from "./subpages/group-sales";

const pageWrapper = css({
  minHeight: '100vh',
  background: 'var(--g-100)',
  display: 'flex',
  flexDirection: 'column',
});

const content = css({
  flex: 1,
});

export function Commercial() {
  return (
    <>
      <Navbar />
      <div className={pageWrapper}>
        <div className={content}>
          <Routes>
            <Route index element={<CommercialIndex />} />
            <Route path="patrocinador" element={<Sponsor />} />
            <Route path="vender-evento" element={<SellEvent />} />
            <Route path="vendas-grupos" element={<GroupSales />} />
          </Routes>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Commercial;
